import { Autocomplete, TextField } from "@mui/material";
import React, { memo, useCallback, useMemo } from "react";

const CustomSelect = (props) => {
  const {
    data,
    options = [],
    disabled,
    endAdornment,
    value = "",
    onChange,
    getLabel = null,
    multiple = false,
  } = props;

  const handleChange = useCallback(
    (name, value) => {
      onChange(name, value);
    },
    [onChange]
  );

  const memoizedEndAdornment = useMemo(() => endAdornment, [endAdornment]);
  return (
    <Autocomplete
      multiple={multiple}
      fullWidth
      value={value}
      key={data?.name}
      disabled={disabled}
      options={options}
      onChange={(e, value) => {
        handleChange(data.name, value);
      }}
      getOptionLabel={(option) =>
        getLabel ? getLabel(option) : option[data.name] || option
      }
      renderInput={(params) => (
        <TextField
          {...params}
          margin="normal"
          label={data.label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {memoizedEndAdornment}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default memo(CustomSelect);
